import React, { useState, useEffect, memo } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import InputMask from 'react-input-mask';
import { useTranslation } from 'react-i18next';
import Avatar from 'react-avatar';

import './StyleModal.css';

import { UserActions } from '../../../store/actions/users';

import UploadFotoProfile from './Components/UploadFotoProfile';
import iconView from '../../../assets/images/icone_view.svg';
import iconEsconder from '../../../assets/images/icone_esconder.svg';
import iconBack from '../../../assets/images/back.svg';

export const passwordRegex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;

function Modal(props) {
  const { i18n } = useTranslation();

  const { user } = props;
  const [isPass, setIsPass] = useState(false);
  const [isNewPass, setIsNewPass] = useState(false);
  const [isConfirmPass, setIsConfirmNewPass] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [name, setName] = useState('');
  const [cpf, setCpf] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [phone, setPhone] = useState('');
  const [cep, setCep] = useState('');
  const [address, setAddress] = useState('');
  const [addressNeighborhood, setAddressNeighborhood] = useState('');
  const [addressCity, setAddressCity] = useState('');
  const [addressState, setAddressState] = useState('');
  const [addressCountry, setAddressCountry] = useState('');
  const [email, setEmail] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [password, setPassword] = useState('');
  const [retry, setRetry] = useState(0);
  const [profilePhoto, setProfilePhoto] = useState();

  useEffect(() => {
    if (retry < 3) {
      if (user?._id) {
        setRetry(0);
        // eslint-disable-next-line no-use-before-define
        onInfo();
      } else {
        // eslint-disable-next-line no-shadow
        setRetry((retry) => retry + 1);
      }
    }
  }, [user]);
  /* funcao carrega dados do usuario */
  const onInfo = () => {
    setName(user.name ? user.name : '');
    setCpf(user.cpf ? user.cpf : '');
    setBirthDate(user.birthDate ? user.birthDate : '');
    setPhone(user.phone ? user.phone : '');
    setCep(user.cep ? user.cep : '');
    setAddress(user.address ? user.address : '');
    setAddressNeighborhood(
      user.addressNeighborhood ? user.addressNeighborhood : ''
    );
    setAddressCity(user.addressCity ? user.addressCity : '');
    setAddressState(user.addressState ? user.addressState : '');
    setAddressCountry(user.addressCountry ? user.addressCountry : '');
    setEmail(user.email ? user.email : '');
    setProfilePhoto(user.profilePhoto ? user.profilePhoto : '');
  };

  /* funcao salva novos dados usuario banco de dados */
  const save = () => {
    const { updateUser } = props;

    if (name.trim().length === 0) {
      toastr.error(i18n.t('Erro'), i18n.t('Digite o nome do usuário.'));
    } else if (email.trim().length === 0) {
      toastr.error(i18n.t('Erro'), i18n.t('Digite o email do usuário.'));
    } else if (phone.trim().length === 0) {
      toastr.error(i18n.t('Erro'), i18n.t('Digite o telefone do usuário.'));
    } else if (password === '') {
      // const pass = await hashService.hash('1234567890');
      const data = {
        _id: user._id,
        name,
        cpf,
        birthDate,
        phone,
        cep,
        address,
        addressNeighborhood,
        addressCity,
        addressState,
        addressCountry,
        email,
        profilePhoto,
      };
      updateUser(data);
    } else if (password === confirmPassword) {
      if (!passwordRegex.test(password)) {
        toastr.error(
          'Erro',
          'A senha deve ser composta de 1 caracter maiusculo, 1 minusculo e 1 número e conter pelo menos 6 caracteres'
        );
      } else {
        const data = {
          _id: user._id,
          name,
          cpf,
          birthDate,
          phone,
          cep,
          address,
          addressNeighborhood,
          addressCity,
          addressState,
          addressCountry,
          email,
          password_hash: password,
          old_password: oldPassword,
          profilePhoto,
        };
        updateUser(data);
      }
    } else {
      toastr.error('Erro', 'As senhas devem ser iguais');
    }
  };

  return (
    <div className="containerUser">
      <div className="container-voltar-perfil">
        <Link to="/home">
          <span className="voltar-user">
            <img
              src={iconBack}
              alt="Voltar"
              style={{ height: 19, marginBottom: 3 }}
            />
          </span>
        </Link>
        <span className="title-user">Perfil</span>
        <button
          type="button"
          className="btn-cancelar"
          onClick={() => setIsEdit(!isEdit)}
        >
          {isEdit ? 'cancelar' : 'editar'}
        </button>
      </div>

      {isEdit ? (
        <UploadFotoProfile
          name={name}
          currentFile={profilePhoto}
          setCurrentFile={setProfilePhoto}
        />
      ) : (
        <div className="container-imagem-Profile">
          {profilePhoto ? (
            <img
              className="img-profile"
              src={profilePhoto}
              alt="imagem-profile"
            />
          ) : (
            <div className="img-profile">
              <Avatar
                name={name}
                size="100"
                round
                color={Avatar.getRandomColor('sitebase', [
                  'red',
                  'green',
                  'blue',
                  'gray',
                ])}
              />
            </div>
          )}
          <span>{name}</span>
        </div>
      )}

      <div className="inputs-header-user">
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Nome: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Informe o seu nome"
              />
            </div>
          )) ||
            (name && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{name}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>------------</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>CPF: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
                placeholder="Informe o seu CPF"
                maskChar=""
                mask="999.999.999-99"
              />
            </div>
          )) ||
            (cpf && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{cpf}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>xxx-xxx-xxx-xx</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Nasc.: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                placeholder="Informe a Data de nascimento"
                maskChar=""
                mask="99/99/9999"
              />
            </div>
          )) ||
            (birthDate && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{birthDate}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>--/--/----</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Telefone: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Informe o Telefone"
                maskChar=""
                mask="(99) 9 9999-9999"
              />
            </div>
          )) ||
            (phone && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{phone}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>(--) ----------</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Cep: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={cep}
                onChange={(e) => setCep(e.target.value)}
                placeholder="Informe o CEP"
                maskChar=""
                mask="99999-999"
              />
            </div>
          )) ||
            (cep && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{cep}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>---------</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Rua: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                placeholder="Informe a Rua"
              />
            </div>
          )) ||
            (address && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{address}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>------------</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Bairro: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={addressNeighborhood}
                onChange={(e) => setAddressNeighborhood(e.target.value)}
                placeholder="Qual seu Bairro?"
              />
            </div>
          )) ||
            (addressNeighborhood && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{addressNeighborhood}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>------------</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Cidade: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={addressCity}
                onChange={(e) => setAddressCity(e.target.value)}
                placeholder="Qual sua cidade"
              />
            </div>
          )) ||
            (addressCity && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{addressCity}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>------------</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>UF: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={addressState}
                onChange={(e) => setAddressState(e.target.value)}
                placeholder="Informe a UF do seu estado"
              />
            </div>
          )) ||
            (addressState && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{addressState}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>--</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>País: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={addressCountry}
                onChange={(e) => setAddressCountry(e.target.value)}
                placeholder="Qual o seu País?"
              />
            </div>
          )) ||
            (addressCountry && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{addressCountry}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>------------</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Email: </p>
          </div>
          {(isEdit && (
            <div className="input-user-page">
              <InputMask
                style={{ width: 350, height: 35 }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Informe o Email"
                disabled
              />
            </div>
          )) ||
            (email && (
              <div style={{ height: 25 }}>
                {' '}
                <span>{email}</span>{' '}
              </div>
            )) || (
              <div style={{ height: 25 }}>
                <span>------------</span>{' '}
              </div>
            )}
        </div>
        <div className="container-inptus-header-user">
          <div style={{ width: 100 }}>
            <p>Senha atual: </p>
          </div>
          {isEdit ? (
            <div className="input-user-page">
              <InputMask
                style={{ width: 320, height: 35 }}
                placeholder="**********"
                type={isPass ? 'text' : 'password'}
                onChange={(e) => setOldPassword(e.target.value)}
                value={oldPassword}
                maskChar=""
                maxLength="30"
              />
              <img
                style={{ width: 25, marginRight: 10 }}
                src={isPass ? iconView : iconEsconder}
                onClick={() => setIsPass(!isPass)}
                alt=""
              />
            </div>
          ) : (
            <div style={{ height: 30 }}>
              {' '}
              <span>**********</span>{' '}
            </div>
          )}
        </div>
        {isEdit ? (
          <div className="container-inptus-header-user">
            <div style={{ width: 100 }}>
              <p>Nova senha: </p>
            </div>
            <div className="input-user-page">
              <InputMask
                style={{ width: 320, height: 35 }}
                placeholder="Nova Senha"
                type={isNewPass ? 'text' : 'password'}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                maskChar=""
                maxLength="30"
              />
              <img
                style={{ width: 25, marginRight: 10 }}
                src={isNewPass ? iconView : iconEsconder}
                onClick={() => setIsNewPass(!isNewPass)}
                alt=""
              />
            </div>
          </div>
        ) : (
          <div />
        )}
        {isEdit ? (
          <div className="container-inptus-header-user">
            <div style={{ width: 100 }}>
              <p>Confirmação Senha: </p>
            </div>

            <div className="input-user-page">
              <InputMask
                style={{ width: 320, height: 35 }}
                placeholder="Confirmação de senha"
                type={isConfirmPass ? 'text' : 'password'}
                onChange={(e) => setConfirmPassword(e.target.value)}
                value={confirmPassword}
                maskChar=""
                maxLength="30"
              />
              <img
                style={{ width: 25, marginRight: 10 }}
                src={isConfirmPass ? iconView : iconEsconder}
                onClick={() => setIsConfirmNewPass(!isConfirmPass)}
                alt=""
              />
            </div>
          </div>
        ) : (
          <div />
        )}
      </div>

      <div className="ft-button-user">
        {isEdit && (
          <button type="button" onClick={save}>
            salvar
          </button>
        )}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.users.signedUser,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...UserActions }, dispatch);

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(memo(Modal))
);
